import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        tableCell: {
            padding: '5px !important',
        },
        selectIcon: {
            top: '-2px !important',
        },
        inputCentered: {
            textAlign: 'center',
        },
        cellSmall: {
            maxWidth: 80,
        },
        temperatureRange: {
            width: '20%',
        },
        productType: {
            width: '30%',
        },
        inputs: {
            width: '10%',
        },
        input: {
            '&&': {
                backgroundColor: theme.palette.secondary[50],
                paddingLeft: theme.spacing(0.25),
                color: theme.palette.secondary[600],
                fontSize: theme.typography.body1.fontSize,
            },
        },
        inputBase: {
            '&&': {
                width: '100%',
                '& input': {
                    paddingLeft: theme.spacing(0.25),
                },
            },
        },
        deleteIcon: {
            cursor: 'pointer',
            color: theme.palette.secondary[600],
        },
        containerSelector: {
            '& .MuiInput-underline:before': {
                border: 'none',
            },
        },
        background: {
            '&&': {
                backgroundColor: theme.palette.secondary[50],
                paddingLeft: theme.spacing(0.25),
            },
        },
        required: {
            '&&': {
                paddingLeft: theme.spacing(0.25),
                backgroundColor: theme.palette.primary[30],
            },
        },
        locationCell: {
            width: '20%',
        },
        location: {
            '&&': {

                backgroundColor: theme.palette.primary[30],
                height: 30,
                '& p': {
                    display: 'none',
                },
                '& img': {
                    display: 'none',
                },
                '& .MuiInput-underline:before': {
                    display: 'none',
                },
                '& .MuiInput-underline': {
                    paddingRight: 0,
                },
                '& .MuiInputBase-input': {
                    padding: '4px 0px 5px !important',
                },
                paddingLeft: theme.spacing(0.25),
            },
        },
        locationLabelContainer: {
            paddingTop: '0 !important',
        },
        disabled: {
            backgroundColor: 'initial !important',
        },
    }
})

export default useStyles
